import FdxDisablePasteDirective from './fdx-disable-paste/fdx-disable-paste.directive.js';

angular.module('feedAuthApp')
  .directive('fdxDisablePaste', FdxDisablePasteDirective);